import { DMLActions } from './DMLActions'

/** Описание элементов в Document and Media Liferay
 * 
*/

const initialLDMLState = {
    state: "empty",
    items: [],
}

/** Добавляет в дерево папок и файлов дочитанные узлы */
const inculdeChilderInTree = (items, action) => {
  for (let i=0; i<items.length; i++) {
    if (items[i].folderId == action.parentId){
      items[i].children = action.items;
      return true;
    }
    if (items[i].children && Array.isArray(items[i].children) && items[i].children.length>0)
      if (inculdeChilderInTree(items[i].children, action))
       return true;
  }
  return false;
}

export const ldml = (state = { ...initialLDMLState} , action) => {
  switch (action.type) {
    case "DMLActions.EMPTY":
      return{
        ...initialLDMLState,
      };
    case "DMLActions.LOAD_STARTED":
      return{
        ...state,
        state: "load",
    };
    case "DMLActions.LOAD_ERROR":
      return {
        ...initialLDMLState,
        error: action.error,
        state: "error",
    };
    case "DMLActions.ITEMS":
      return {
        ...state,
        items: action.items,
        state: "loaded",
    };
    case "DMLActions.SELECTED":
      return {
        ...state,
        file: action.item,
    };
    case "DMLActions.CHILDREN":
      const {items} = state;
      const np = [... items];
      inculdeChilderInTree(np, action);
      return {
        ...state,
        items: np,
        state: "loaded",
    };
    default:
      return state;
  }
}
